// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.33.4
// source: bridge/models/chain.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "core.bridge";

export enum ChainType {
  EVM = 0,
  BITCOIN = 1,
  COSMOS = 2,
  OTHER = 3,
  ZANO = 4,
  TON = 5,
  SOLANA = 6,
  UNRECOGNIZED = -1,
}

export function chainTypeFromJSON(object: any): ChainType {
  switch (object) {
    case 0:
    case "EVM":
      return ChainType.EVM;
    case 1:
    case "BITCOIN":
      return ChainType.BITCOIN;
    case 2:
    case "COSMOS":
      return ChainType.COSMOS;
    case 3:
    case "OTHER":
      return ChainType.OTHER;
    case 4:
    case "ZANO":
      return ChainType.ZANO;
    case 5:
    case "TON":
      return ChainType.TON;
    case 6:
    case "SOLANA":
      return ChainType.SOLANA;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ChainType.UNRECOGNIZED;
  }
}

export function chainTypeToJSON(object: ChainType): string {
  switch (object) {
    case ChainType.EVM:
      return "EVM";
    case ChainType.BITCOIN:
      return "BITCOIN";
    case ChainType.COSMOS:
      return "COSMOS";
    case ChainType.OTHER:
      return "OTHER";
    case ChainType.ZANO:
      return "ZANO";
    case ChainType.TON:
      return "TON";
    case ChainType.SOLANA:
      return "SOLANA";
    case ChainType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface Chain {
  id: string;
  type: ChainType;
  /** bridge_address is the address of the bridge contract on the chain */
  bridgeAddress: string;
  /** operator is the address of the operator of the bridge contract */
  operator: string;
  confirmations: number;
  name: string;
}

function createBaseChain(): Chain {
  return { id: "", type: 0, bridgeAddress: "", operator: "", confirmations: 0, name: "" };
}

export const Chain: MessageFns<Chain> = {
  encode(message: Chain, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.type !== 0) {
      writer.uint32(16).int32(message.type);
    }
    if (message.bridgeAddress !== "") {
      writer.uint32(26).string(message.bridgeAddress);
    }
    if (message.operator !== "") {
      writer.uint32(34).string(message.operator);
    }
    if (message.confirmations !== 0) {
      writer.uint32(40).uint32(message.confirmations);
    }
    if (message.name !== "") {
      writer.uint32(50).string(message.name);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Chain {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChain();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.bridgeAddress = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.operator = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.confirmations = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.name = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Chain {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      type: isSet(object.type) ? chainTypeFromJSON(object.type) : 0,
      bridgeAddress: isSet(object.bridgeAddress)
        ? globalThis.String(object.bridgeAddress)
        : isSet(object.bridge_address)
        ? globalThis.String(object.bridge_address)
        : "",
      operator: isSet(object.operator) ? globalThis.String(object.operator) : "",
      confirmations: isSet(object.confirmations) ? globalThis.Number(object.confirmations) : 0,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
    };
  },

  toJSON(message: Chain): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.type !== 0) {
      obj.type = chainTypeToJSON(message.type);
    }
    if (message.bridgeAddress !== "") {
      obj.bridgeAddress = message.bridgeAddress;
    }
    if (message.operator !== "") {
      obj.operator = message.operator;
    }
    if (message.confirmations !== 0) {
      obj.confirmations = Math.round(message.confirmations);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Chain>, I>>(base?: I): Chain {
    return Chain.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Chain>, I>>(object: I): Chain {
    const message = createBaseChain();
    message.id = object.id ?? "";
    message.type = object.type ?? 0;
    message.bridgeAddress = object.bridgeAddress ?? "";
    message.operator = object.operator ?? "";
    message.confirmations = object.confirmations ?? 0;
    message.name = object.name ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
